import { formatProductAttributeTitle } from './titleFormat';

/**
 * @param {Object[]} all
 * @param {string} searchQuery
 * @returns {Object[]}
 */
const makeSearchItems = (all, searchQuery) => {
  const normalizedQuery = searchQuery.toLowerCase();

  return all.filter((node) => {
    if (node.type === 'separator') {
      return node.title.toLowerCase().includes(normalizedQuery);
    }

    const rawTitle = node.title.toLowerCase();
    const displayTitle = formatProductAttributeTitle(node.title).toLowerCase();

    return rawTitle.includes(normalizedQuery) || displayTitle.includes(normalizedQuery);
  });
};

export default makeSearchItems;
